//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../LineDesigner/LineDesigner.JigOnPlaneBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/KFObject.js";
import "../no/Section.js";
let d=[[[0,"AddRailingToggle",1,0],[0,"CenterlineJigOnPlane",1,"LineDesigner.JigOnPlaneBuilder",0],[1,"DeckCeilingHeightForCenterline",0,"Expression",0],[1,"DeckCeilingHeightForPolyline",0,"Expression",0],[1,"DeckElevationForCenterline",0,"Expression",0],[1,"DeckElevationForPolyline",0,"Expression",0],[1,"DeckHeightForCenterline",0,"Expression",0],[1,"DeckHeightForPolyline",0,"Expression",0],[1,"DeckLengthForCenterline",0,"Expression",0],[0,"DeckSupportEnum",1,0],[1,"DeckThicknessForCenterline",0,"Expression",0],[1,"DeckThicknessForPolyline",0,"Expression",0],[1,"DeckWidthForCenterline",0,"Expression",0],[0,"DeckingMaterial",1,0],[1,"DistanceFromCenterline",0,"Expression",0],[1,"HorizontalGridSpacing",0,"Expression",0],[0,"IsSketchInternal",1,0],[0,"KfObject",0,"KFObject",0],[0,"OutlineEnum",1,0],[1,"PolylineSuperSection",0,"Section",0],[0,"SideFromCenterlineEnum",1,0],[0,"StatusOfPlatformCeilingHeightUpdation",1,0],[0,"StatusOfPlatformElevationUpdation",1,0],[0,"StatusOfPlatformHeightUpdation",1,0],[0,"StatusOfPlatformSupportDefaultFromCeilingToggleUpdation",1,0],[0,"StatusOfPlatformSupportOptionUpdation",1,0],[0,"StatusOfPlatformThicknessUpdation",1,0],[0,"SupportsFromCeiling",1,0],[0,"TypeEnum",1,0],[1,"VerticalGridSpacing",0,"Expression",0]],[[[],"SupportCrossSectionButton",{},0,0]],[]];
SPLM.LineDesigner.PlatformEquipmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.PlatformEquipmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.PlatformEquipmentBuilder.TypeAPI = Object.freeze({
    "Platform" : "Platform", "Mezzanine" : "Mezzanine"});

SPLM.LineDesigner.PlatformEquipmentBuilder.OutlineTypeAPI = Object.freeze({
    "Polyline" : "Polyline", "Centerline" : "Centerline"});

SPLM.LineDesigner.PlatformEquipmentBuilder.SideFromCenterlineTypeAPI = Object.freeze({
    "RightTopSide" : "RightTopSide", "LeftBottomSide" : "LeftBottomSide"});

SPLM.LineDesigner.PlatformEquipmentBuilder.DeckSupportTypeAPI = Object.freeze({
    "NoSupports" : "NoSupports", "CornersSupportsOnly" : "CornersSupportsOnly", "AutomaticSupportinGridPattern" : "AutomaticSupportinGridPattern", "ManualSupports" : "ManualSupports"});

SPLM.LineDesigner.PlatformEquipmentBuilder.DeckingMaterialTypeAPI = Object.freeze({
    "MetalGrate" : "MetalGrate", "CheckerPlate" : "CheckerPlate"});

export default SPLM;